<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/bwt/ds1-banner.jpg`)})`}">
			<div class="container">
				<div class="row">
					<div class="col-lg-8 col-xl-6">
						<div class="inner text-start" data-aos="fade-up" data-aos-delay="100">
							<h2 class="w-600 title text-left">数据治理咨询与实施服务</h2>
							<h4 class="text-left color-white">确保业务决策的可靠性与高效率</h4>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">业务挑战</h2>
				<div style="margin-top: 48px; font-size: 18px">
					<div class="function-inner">
						<div class="edit-container">
							<ul class="clearfix">
								<li>
									<div class="block-box js-m delay1 animate">
										<div class="title">数据战略与体系转型困难</div>
										<div class="cont">企业缺乏统一的数据顶层战略规划和系统化的数据治理体系，未建立健全的数据管理机制与体系，导致数据管理碎片化，无法有效支撑企业的长远发展和数字化转型目标。</div>
									</div>
								</li>
								<li>
									<div class="block-box js-m delay2 animate">
										<div class="title">数据质量和安全性风险高</div>
										<div class="cont">数据质量不稳定，且安全性难以保障，特别是在多系统集成和跨部门协作中，数据错误和数据泄露风险增大，给企业带来潜在的法律和合规风险。</div>
									</div>
								</li>
								<li>
									<div class="block-box js-m delay3 animate">
										<div class="title">复杂流程管理难度大</div>
										<div class="cont">企业面临海量数据和复杂业务流程的管理挑战，数据源繁多且分散，数据一致性难以保障，导致决策滞后和业务运作效率低下。</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>

		<separator />

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">服务优势</h2>
				<div class="product" data-aos="fade-up" data-aos-delay="100">
					<div class="txt" >
						<div class="swiper-container">
							<div class="eee">
								<div class="t1">数据治理与实施服务</div>
								<div class="t2">以高阶专业视角定制解决方案，结合行业最佳实践，覆盖数据全生命周期管理，确保策略落地执行，助力企业构建高效、可持续的数据管理体系，推动数字化转型。</div>
							</div>
							<div class="label-list">
								<dl class="clearfix">
									<dd>
										<div class="block-box">
											<div class="txt1">全面盘点，建立数据资产目录，确保数据资源的有效管理和利用。</div>
										</div>
									</dd>
									<dd>
										<div class="block-box">
											<div class="txt1">统一数据标准，提升数据准确性和一致性，保障决策可靠性。</div>
										</div>
									</dd>
									<dd>
										<div class="block-box">
											<div class="txt1">构建行业特定数据指标体系，推动数据驱动的决策和业务增长。</div>
										</div>
									</dd>
								</dl>
							</div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/bwt/ds1.jpg" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
export default {
	name: 'About',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/bwt/sbg.jpg");
}
.edit-container {
	position: relative;
	ul {
		margin: 0 -10px;
		display: block;
		li {
			display: inline-block;
			vertical-align: top;
			width: 33.333%;
			padding: 0 10px;
			text-align: left;
			margin-top: 15px;

			.block-box {
				padding: 34px 42px;
				position: relative;
				font-size: 16px;
				background-color: #f7f9fc;
				box-shadow: 0 10px 12px rgba(148, 160, 175, 0.33);
				border-radius: 8px;
				overflow: hidden;

				&:before {
					content: '';
					width: 100%;
					height: 6px;
					background: linear-gradient(to right, #c60c1a, #2270b2);
					position: absolute;
					left: 0;
					bottom: 0;
				}

				.title {
					font-size: 20px;
					font-weight: bold;
					height: 60px;
				}

				.cont {
					line-height: 1.8;
					height: 160px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 6;
					-webkit-box-orient: vertical;
				}
			}
		}
	}
}

.product {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		width: 60%;
		margin-top: 48px;
		.eee {
			width: 90%;
			text-align: left;
			.t1 {
				font-size: 24px;
				font-weight: 600;
				color: #000;
			}
			.t2 {
				margin-top: 12px;
				color: #000;
			}
		}
	}
}
.label-list {
	.clearfix {
		display: block;
	}
	dl {
		margin: 0 -8px;
		dd {
			padding: 0 8px;
			margin: 16px 32px 0 0;

			.block-box {
				background: url('../../../assets/images/bwt/label-bg.jpg') bottom right no-repeat #e2e9f0;
				background-size: 30% auto;
				border-radius: 16px;
				font-size: 14px;
				padding: 12px;
				.txt1 {
					color: black;
				}
			}
		}
	}
}
</style>
